import { PERMISSIONS } from '../config/permissions.config.js';
import { getRole } from '../utils/role';

export const hasPermission = (permission) => {
  let role = getRole();
  if (!role) return false;

  if (role === 'TEAM_MEMBER') {
    role = 'PARTNER';
  }

  if (PERMISSIONS[role]?.['*']) return true;

  const [module, action] = permission.split(':');
  return PERMISSIONS[role]?.[module]?.includes(action);
};
